import Swiper, { Navigation, Autoplay} from 'swiper';

const locationSlides = new Swiper('.location__slides', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    prevEl: '.location__slides-btn_dir_prev',
    nextEl: '.location__slides-btn_dir_next',
  },
});
const regionsArr = locationSlides.slides.map(item => item.getAttribute('data-key'));
const defaultMapParams = {
  fillColor: '#F1F3EA',
  fillOpacity: 0.8,
  strokeWidth: 1,
  strokeColor: '#888',
  coordRendering: 'shortestPath'
};

function replacePrefix(item) {
  return item.toLowerCase().replace('ru-','');
}

if ($('#map').length)
  ymaps.ready(init); 

function init(){
  const map = new ymaps.Map('map', {
    //center: [61.011424613757356,78.35393286269212],
    center: [63.442430528433064,99.89934201509027],
    zoom: 2,
    type: null,
    controls: ['zoomControl']
  }, {
    //restrictMapArea: [[33.35632616176579,-6.021067137307907],[75.8412043010751,162.7289328626921]]
    restrictMapArea: [[-1.5585383120961696,-68.85065798490973],[83.76090298876326,-91.35065798490974]]
  });
  map.controls.get('zoomControl').options.set({size: 'small'});

  ymaps.borders.load('001', {
    lang: 'ru',
    quality: 2
  }).then(result => {
    const bg = new ymaps.Polygon([
      [
        [85, -179.99],
        [85, 179.99],
        [-85, 179.99],
        [-85, -179.99],
        [85, -179.99]
      ]
    ], {}, {
      fillColor: '#ffffff',
      strokeWidth: 0,
      coordRendering: 'straightPath'
    });

    const mapData = result.features.filter(feature => feature.properties.iso3166 == 'KZ');
    const region = new ymaps.Polygon(mapData[0].geometry.coordinates, {}, defaultMapParams);
    map.geoObjects.add(bg);
    map.geoObjects.add(region);
    region.events.add('mouseenter', e => {
      e.get('target').options.set({fillOpacity: 1});
    });
    region.events.add('mouseleave', e => {
      e.get('target').options.set({fillOpacity: 0.8});
    });
    region.events.add('click', e => {
      locationSlides.slideTo(regionsArr.indexOf(mapData[0].properties.iso3166));
    });
  });

  ymaps.borders.load('RU', {
    lang: 'ru',
    quality: 2
  }).then(result => {
    const mapParams = {};
    const regionKeysArr = result.features.map(item => item.properties.iso3166);

    regionKeysArr.forEach(regionKeysArrEl => {
      mapParams[replacePrefix(regionKeysArrEl)] = {};
      for(let key in defaultMapParams) {
        mapParams[replacePrefix(regionKeysArrEl)][key] = defaultMapParams[key];
      }
      if(regionsArr.filter(item => item == regionKeysArrEl).length) {
        mapParams[replacePrefix(regionKeysArrEl)].fillColor = '#C0DDFC';
      } else {
        mapParams[replacePrefix(regionKeysArrEl)].fillColor = '#FAFBFC';
      }
    });

    result.features.forEach(resultEl => {
      const key = replacePrefix(resultEl.properties.iso3166);
      const region = new ymaps.Polygon(resultEl.geometry.coordinates, {}, mapParams[key]);
      map.geoObjects.add(region);
      region.events.add('mouseenter', e => {
        e.get('target').options.set({fillOpacity: 1});
      });
      region.events.add('mouseleave', e => {
        e.get('target').options.set({fillOpacity: 0.8});
      });
      region.events.add('click', e => {
        if(regionsArr.indexOf(resultEl.properties.iso3166) != -1) {
          locationSlides.slideTo(regionsArr.indexOf(resultEl.properties.iso3166));
        }
      });
    });
  });
}
